import React from 'react';
import FormatService from 'src/services/format.service';
import LiteralsService from 'src/services/literals/LiteralsService';
import styles from './spendingBreakdown.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';
import colors from 'src/styles/colors.module.scss';

interface SpendingBreakdownProps {
    spent: number;
    averageMonthlySpent: number;
    className?: string;
    isMinWidthSmall?: boolean;
}
export default function SpendingBreakdown({
    spent,
    averageMonthlySpent,
    className,
    isMinWidthSmall
}: SpendingBreakdownProps): JSX.Element {
    const formattedSpent: string = FormatService.formatCurrency(spent);
    const formattedAverageMonthlySpent: string = FormatService.formatCurrency(averageMonthlySpent, { round: true });

    return (
        <div className={`${styles.spendingBreakdown} ${className}`}>
            <Typography
                variant={TypographyVariants.HEADING_XS}
                data-cy={Selectors.SpendSmart.SPENDING_BREAKDOWN_SPENT}
                component="p"
            >
                {formattedSpent}
            </Typography>
            <span data-cy={Selectors.SpendSmart.SPENDING_BREAKDOWN_AVERAGE_MONTHLY_SPENT}>
                <Typography variant={TypographyVariants.LEGAL_PRIMARY} className={colors.textWeak}>
                    {LiteralsService.getLiteral(`SpendingBreakdown.${isMinWidthSmall ? 'avgMonthFull' : 'avgMonth'}`)}
                </Typography>
                <Typography variant={TypographyVariants.LEGAL_PRIMARY} className={colors.textWeak}>
                    {formattedAverageMonthlySpent}
                </Typography>
            </span>
        </div>
    );
}
